export const AddFileToVideoMutation = `
mutation getVideoFiles($mediaitemids:[Int]!,$postpartid:Int!){
  AddVideoFile(mediaitemids:$mediaitemids,postpartid:$postpartid){
    mediaitems{
      mediaitemid
      content
    }
  }
}`;
